var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserBonusSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill: #3398CB; } /* \u5C07 cls-1 \u7684\u984F\u8272\u8A2D\u7F6E\u70BA #3398CB */\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-userBonus",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 26,
    height: 26,
    transform: "translate(3 3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_24",
    "data-name": "Exclusion 24",
    d: "M154.69,211.35H101.31l-1.62,0a39.85,39.85,0,0,1-35.25-23.37,41.3,41.3,0,0,1,4.68-43c21.76-28.1,36.17-49.55,40.57-60.39l.29-.74c2.28-5,.92-12.15.9-12.22A26.82,26.82,0,0,0,84.49,48.65v-4A30.81,30.81,0,0,1,114.84,70.9c.05.25,1.59,8.37-1.18,14.5l-.24.61c-5.82,14.33-25.58,41.27-41.13,61.35a37.31,37.31,0,0,0-4.22,38.88,35.91,35.91,0,0,0,31.76,21.08l1.48,0h53.37l1.48,0a35.91,35.91,0,0,0,31.76-21.08,37.31,37.31,0,0,0-4.22-38.88c-22.3-28.8-36.13-49.43-41.1-61.3-2.89-6.89-1.52-14.73-1.46-15.06a30.75,30.75,0,0,1,30.37-26.36v4a26.76,26.76,0,0,0-26.42,23c0,.15-1.22,7.11,1.2,12.89,4.77,11.39,18.8,32.27,40.58,60.39a41.3,41.3,0,0,1,4.68,43,39.85,39.85,0,0,1-35.25,23.37Z",
    stroke: "#3398CB",
    strokeWidth: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.61,161.81c0,6.42-4.51,10.93-12.16,11.54V181h-4.21v-7.68a21.92,21.92,0,0,1-12.86-6.17l3.28-3.93a17.86,17.86,0,0,0,12.13,5.22c4.64,0,8.07-2.3,8.07-6.26,0-4.51-3.62-6-9.42-7.83-6.88-2.21-13.14-4.36-13.14-11.85,0-6.11,4.27-10.74,11.94-11.11v-8h4.21v8.23a25.72,25.72,0,0,1,10.71,4.57L138,140.1a19.52,19.52,0,0,0-10.59-3.71c-4.39,0-7.46,2.06-7.46,5.74,0,3.93,3.81,5.37,9.06,7.09,7.74,2.46,13.6,4.51,13.6,12.59Z",
    transform: "translate(3 3) ",
    fill: "#3398CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserBonusSelect);
export default __webpack_public_path__ + "static/media/icon-user-bonus-select.a5ff66a53c811afe9068379f90dbeb52.svg";
export { ForwardRef as ReactComponent };